import React from 'react';
import { 
  FooterContainer,
  Logo
 } from '../styles/FooterStyles';


const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <Logo>Daniel Almeida | Developer Front End/Mobile </Logo>
    </FooterContainer>
  );
};

export default Footer;
